import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wv-contract-edit',
  templateUrl: './wv-contract-edit.component.html',
  styleUrls: ['./wv-contract-edit.component.scss']
})
export class WvContractEditComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
